<template>
  <v-container fluid>
    <v-card outlined class="mt-2">
      <v-card-title>Вопросы для комиссии</v-card-title>
      <v-card-text>
        <CompareRow tag="hasQuestions" v-slot="{ value, change }">
          <v-switch
            :input-value="!!value"
            label="Есть ли вопросы к комиссии?"
            color="primary"
            hide-details
            class="mt-0"
            @change="v => change(v)"
          />
        </CompareRow>

        <template v-if="showParticipants">
          <v-chip-group
            v-model="activeParticipant"
            mandatory
            active-class="primary--text"
            class="mt-4 mb-2"
          >
            <v-chip
              v-for="(p, pIndex) in participantLabels"
              :key="pIndex"
              :value="pIndex"
              filter
              outlined
            >
              {{ p }}
            </v-chip>
          </v-chip-group>

          <v-card outlined class="pa-3">
            <CompareRow
              :root="`participants[${activeParticipant}]`"
              tag="title"
              v-slot="{ value, change }"
            >
              <v-text-field
                label="Участник"
                :value="value"
                hide-details
                dense
                outlined
                @input="change"
              />
            </CompareRow>

            <div
              v-for="qIndex in questionIndexes"
              :key="qIndex"
              class="mt-4"
            >
              <div class="text-caption font-weight-medium mb-1">
                Вопрос {{ qIndex + 1 }}.
              </div>
              <CompareRow
                :root="`participants[${activeParticipant}].questions[${qIndex}]`"
                tag="text"
                v-slot="{ value, change }"
              >
                <AutoGrowTextEditor
                  :value="value"
                  rows="4"
                  @change="change"
                  @input="change"
                />
              </CompareRow>
            </div>
          </v-card>
        </template>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import CompareRow from '@/components/compare/CompareRow'
import AutoGrowTextEditor from '@/components/editors/AutoGrowTextEditor'
import { normalizeCommissionQuestions } from './const'

export default {
  name: 'CompareCommissionQuestions',
  components: { CompareRow, AutoGrowTextEditor },
  data: () => ({
    activeParticipant: 0,
  }),
  computed: {
    ...mapGetters([
      'compare_data',
      'compare_expertise_0_Data',
      'compare_expertise_1_Data',
    ]),
    normalizedCenter() {
      return normalizeCommissionQuestions(this.compare_data)
    },
    normalizedLeft() {
      return normalizeCommissionQuestions(this.compare_expertise_0_Data)
    },
    normalizedRight() {
      return normalizeCommissionQuestions(this.compare_expertise_1_Data)
    },
    /** Показывать блок, если флаг есть хотя бы в одной колонке (не только в сводной). */
    showParticipants() {
      return (
        this.normalizedCenter.hasQuestions ||
        this.normalizedLeft.hasQuestions ||
        this.normalizedRight.hasQuestions
      )
    },
    participantCount() {
      return Math.max(
        this.normalizedCenter.participants.length,
        this.normalizedLeft.participants.length,
        this.normalizedRight.participants.length
      )
    },
    participantLabels() {
      return Array.from({ length: this.participantCount }, (_, i) => {
        const p =
          this.normalizedCenter.participants[i] ||
          this.normalizedLeft.participants[i] ||
          this.normalizedRight.participants[i] ||
          {}
        const t = String(p.title || '').trim()
        return t || `Участник ${i + 1}`
      })
    },
    questionIndexes() {
      const pIdx = this.activeParticipant
      const count = Math.max(
        this.normalizedCenter.participants[pIdx]?.questions?.length || 0,
        this.normalizedLeft.participants[pIdx]?.questions?.length || 0,
        this.normalizedRight.participants[pIdx]?.questions?.length || 0
      )
      return Array.from({ length: count }, (_, i) => i)
    },
  },
  watch: {
    participantLabels() {
      if (this.activeParticipant >= this.participantLabels.length) {
        this.activeParticipant = Math.max(0, this.participantLabels.length - 1)
      }
    },
  },
}
</script>
